<mat-card class="mat-mdc-card mdc-card cardWithShadow overflow-hidden" *ngIf="!showInvoice && !loadingItems">
  <mat-card-content class="mat-mdc-card-content text-center">
    <form [formGroup]="form">
      <ng-container>
        <ng-container>
          <div class="row text-right">
            <div class="col-md-6 m-b-10">
              <mat-label>{{ 'BuyFrom' | translate }}</mat-label>
              <mat-radio-group>
                <mat-radio-button value="0" color="primary" [checked]="!isSupplier" (change)="ChooseBuyFrom(false)">
                  {{ 'treg' | translate }}
                </mat-radio-button>

                <mat-radio-button value="1" color="primary" [checked]="isSupplier"
                                  (change)="ChooseBuyFrom(true)">
                  {{ 'OtherSupplier' | translate }}
                </mat-radio-button>
              </mat-radio-group>
            </div>
            <div class="col-md-4" *ngIf="isSupplier">
              <mat-form-field appearance="outline" class="w-100 m-b-10">
                <input type="text" placeholder="{{ 'SelectSupplier' | translate }}" matInput
                       formControlName="supplierId" [matAutocomplete]="auto">
                <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete"
                                  [displayWith]="displaySupplierFn.bind(this)">
                  <mat-option *ngFor="let option of filteredSuppliersOptions" [value]="option.id">
                    {{ option.name }}
                  </mat-option>
                </mat-autocomplete>

                @if (f['supplierId'].touched && f['supplierId'].invalid) {
                  <mat-hint class="m-b-16 error-msg">
                    @if (f['supplierId'].errors && f['supplierId'].errors['required']) {
                      <div class="text-error"> {{ 'ChooseSupplier' | translate }}</div>
                    }
                  </mat-hint>
                }
                <mat-label>{{ 'Suppliers' | translate }}</mat-label>
              </mat-form-field>
            </div>
          </div>
          <div class="text-right">
            <mat-tab-group (selectedTabChange)="tabClick($event)">
              <mat-tab label="{{'Accessories'|translate}}" *ngIf="ShowAccessoriesTab">
              </mat-tab>

              <mat-tab label="{{'Sectors'|translate}}" *ngIf="ShowSectorsTab">
              </mat-tab>
            </mat-tab-group>

            <ng-container *ngIf="!loadingItems && (ShowAccessoriesTab || ShowSectorsTab)">
              <div *ngIf="isFirstTab && ShowAccessoriesTab;then divAccessories else divSectors"></div>
              <ng-template #divAccessories>
                <app-product-list [list]="AllAccessories" [items]="GetAccessoriesItems" (valueChanged)="UpdateForm($event, 'accessories')"></app-product-list>
              </ng-template>
              <ng-template #divSectors>
                <app-product-list [list]="AllSectors" [items]="GetSectorItems" (valueChanged)="UpdateForm($event, 'sector')"></app-product-list>
              </ng-template>
            </ng-container>
            <div class="text-center" *ngIf="!ShowAccessoriesTab && !ShowSectorsTab">
              {{ 'NoItems'|translate }}
            </div>
          </div>

          <mat-divider></mat-divider>

          <div class="row m-t-24">
            <div class="col-sm-12">
              <button mat-flat-button color="primary" class="orangSavebtn" (click)="submit()">
                {{ 'Save' | translate }}
              </button>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </form>
  </mat-card-content>
</mat-card>

<app-invoice *ngIf="showInvoice" [BuySellOrderData]="DtoBuySellOrder"
             (showInvoice)="CloseInvoice($event)"></app-invoice>
